import {
  clearProduct,
  getCityProvinceData,
  getDesignation,
  getDsoDataByCif,
} from "../modules/console/services/console.service";
import Types from "../constants/types";
import store from "../store/store";
import productSelectionReducer from "../modules/product-selection/redux/product-selection.reducer";
import consoleReducer from "../modules/console/redux/console.reducer";
import PageRoutes from "../constants/page-routes";

/************  City Search Functions ************/
/**
 * @description This function is used to get the city list based on the search value
 * @param {string} value - search value
 * @param {array} cityList - city list
 * @param {function} setCityList - set city list
 * @returns {void}
 * @example
 * onSearchCity("kalutara", cityList, setCityList);
 */
export const onSearchCity = async (value, cityList, setCityList) => {
  let list = cityList.filter((item) => item.ref_desc.toLowerCase().indexOf(value) > -1);

  if (list?.length === 0 && value?.length > 3) {
    const response = await getCityProvinceData(value);
    if (response.ResponseCode === Types.API_SUCCESS_CODE) {
      setCityList(response.data);
    }
  }
};

/************  Designation Search Functions ************/
/**
 * @description This function is used to get the designation list based on the search value
 * @param {string} value - search value
 * @param {array} designationList - designation list
 * @param {function} setDesignationList - set designation list
 * @returns {void}
 * @example
 * onSearchDesignation("manager", designationList, setDesignationList);
 */
export const onSearchDesignation = async (value, designationList, setDesignationList) => {
  let list = designationList.filter((item) => item.ValueText.toLowerCase().indexOf(value) > -1);
  if (list.length === 0 && value.length > 3) {
    const response = await getDesignation(value);
    if (response.ResponseCode === Types.API_SUCCESS_CODE) {
      if (response.Output[0].Values.length > 0) {
        setDesignationList(response.Output[0].Values);
      } else {
        setDesignationList([
          {
            DisplayText: value.toUpperCase(),
            ValueText: value.toUpperCase(),
          },
        ]);
      }
    } else {
      setDesignationList([
        {
          DisplayText: value.toUpperCase(),
          ValueText: value.toUpperCase(),
        },
      ]);
    }
  }
};

export const isDisabled = () => {
  if (store.getState().loginReducer.isExistingUser) {
    const { isHasSaving, isHasCreditCard } = store.getState().productSelectionReducer;
    if (isHasSaving && isHasCreditCard) {
      return false;
    } else if (isHasSaving) {
      return true;
    } else if (isHasCreditCard) {
      return false;
    }
  } else {
    return false;
  }
};

export const handleGoBackToProductionSelection = async () => {
  if (window.location.pathname === `/${PageRoutes.CONSOLE}`) {
    store.dispatch(productSelectionReducer.actions.clearProductSelectionStore());
    store.dispatch(consoleReducer.actions.clearConsoleStore());
    const requestId = store.getState().loginReducer.requestId;
    const cifNo = store.getState().loginReducer.cifNo;

    const response = await clearProduct({
      RequestId: requestId,
    });
    if (response.ResponseCode === Types.API_SUCCESS_CODE) {
      await getDsoDataByCif(requestId, cifNo);
      return true;
    }
    return false;
  }
  return false
};
